import { useEffect, useState } from 'react'
import Modal from '@/components/modal/modal.component'
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';

const MemberRoleModal = ({
    show,
    cancel,
    member,
    orgData,
    setAlertMessage,
    setConfirmMessage,
    approveRef
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    // const [confirmMessage, setConfirmMessage] = useState(null);
    // const [ alertMessage, setAlertMessage ] = useState(null);
    const [ newRole, setNewRole ] = useState(null);
    const [ currentRole, setCurrentRole ] = useState(null);
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        if (!member) return;
        const role = 
            member.roles.includes('manager')
            ?
            'manager'
            :
            'member';
        setCurrentRole(role)
        setNewRole(role)
    }, [member])

    function handleSubmit() {
        if (!newRole || newRole === currentRole) return;
        setConfirmMessage('Are you sure you want to change the role for this user?');
        approveRef.current = () => {
            continueRoleChange();
        }

        async function continueRoleChange() {
            setLoading(true);
            const res = await UseCloudFunction(
                'changeOrgMemberRole', 
                {
                    'orgId': orgData.orgId,
                    'memberAppId': member.appId,
                    'newRole': newRole, 
                    'appId': userProfile.appId,
                    'ts': new Date().getTime(),
                }
            )
            if (res.error) {
                setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
                return;
            }
            setLoading(false);
            cancel();
        }
    }


    return (
        <div className='member-role-modal'>
            { 
            (member && orgData) 
            ?
            <Modal
                show={show}
                cancel={cancel}
                text={`Change Role for ${member.fName} ${member.lName}`}
                closeButton={true}
            >
                
                <div className='member-role-modal-content'>
                    <p>
                        <b>Members: </b>Organization Members are able to add other members as managers or distributors to their own games, and they can share content to other organization members. They cannot add, remove, or change Organization Managers.<br />
                        <b>Managers: </b>Organization Managers have the same permissions as Members, but they also have the ability to add and remove Members and change Member roles. Managers cannot change or remove the Organization Owner.
                    </p>
                    <div className='field'>
                        <label htmlFor='role'>Role</label>
                        <select 
                            name='role' 
                            id='role'
                            value={newRole ?? ''}
                            onChange={e => setNewRole(e.target.value)} >
                            <option value=''>Select Role...</option>
                            <option value='member'>Member</option>
                            <option value='manager'>Manager</option>
                        </select>
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (loading)
                        ?
                        <div className='buttons'>
                            <button className='g-button'>
                                Cancel
                            </button>
                            <button className='g-button'>
                                <ThreeDotsLoader />
                            </button>
                        </div>
                        :
                        <div className='buttons'>
                            <button 
                                className='g-button' 
                                onClick={cancel}>
                                Cancel
                            </button>
                            <button 
                                className={`g-button ${
                                    (
                                        !newRole || 
                                        newRole === currentRole 
                                    )
                                    ? 'disabled' 
                                    : 'primary'
                                }`}
                                onClick={() => handleSubmit()}>
                                Save
                            </button>
                        </div>
                    }
                </div>
            </Modal>
            :
            null
            }
        </div>
    )
}

export default MemberRoleModal